import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ClientProcessingError } from 'app/_errors/client-processing.error';
import { UnknownApplicationError } from 'app/_errors/unknown-application.error';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';

export interface ProcedureOemCompetencyCreate {
  siteId: number;
  competencyTypeId: number;
  manufacturer?: string;
  models?: string[];
  ratings?: string[];
}

export interface ProcedureOemCompetencyDto {
  id: number;
  siteId: number;
  siteName: string;
  competencyTypeName: string;
  competencyTypeId: number;
  competencyType: string;
  manufacturer?: string;
  models?: string[];
  ratings?: string[];
  createdDate: string;
  createdBy: string;
  lastModifiedDate: string;
  lastModifiedBy: string;
  deleted: boolean;
}

@Injectable()
export class ProcedureOemCompetencyService {

  constructor(private http: HttpClient) { }

  public getBySite(siteId: number): Observable<ProcedureOemCompetencyDto[]> {
    return this.http
      .get<ProcedureOemCompetencyDto[]>(environment.competencyApiUrl + 'api/procedure-oem-competency/by-site/' + siteId)
      .pipe(catchError(this.handleError));
  }

  public createProcedureOemCompetency(body: ProcedureOemCompetencyCreate): Observable<ProcedureOemCompetencyDto> {
    return this.http
      .post<ProcedureOemCompetencyDto>(environment.competencyApiUrl + 'api/procedure-oem-competency', body)
      .pipe(catchError(this.handleError));
  }

  public delete(id: number): Observable<void> {
    return this.http
      .delete<void>(environment.competencyApiUrl + 'api/procedure-oem-competency/' + id)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: any) {
    if (error instanceof HttpErrorResponse) {
      return throwError(error);
    }

    if (error instanceof Error) {
      return throwError(
        new ClientProcessingError('The application could not process the server response.', error)
      );
    }

    return throwError(
      new UnknownApplicationError('The application threw an unknown error value.', error)
    );
  }
}
